import { __extends } from "tslib";
import * as React from 'react';
import { ProductLineItemDataHook } from '../../ProductLineItem';
import * as _ from 'lodash';
import { classes, st } from './Options.st.css';
import { TextButton, TextButtonPriority } from 'wix-ui-tpa';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown';
import ChevronUp from 'wix-ui-icons-common/on-stage/ChevronUp';
var defaultMaxValueLength = 35;
export var ProductLineItemOptionsDataHook;
(function (ProductLineItemOptionsDataHook) {
    ProductLineItemOptionsDataHook["collapseExpandButton"] = "ProductLineItemOptionsDataHook.collapseExpandButton";
})(ProductLineItemOptionsDataHook || (ProductLineItemOptionsDataHook = {}));
var Options = /** @class */ (function (_super) {
    __extends(Options, _super);
    function Options(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.getValue = function (value) {
            var maxOptionValLength = _this.props.maxOptionValLength;
            var maxValueLength = maxOptionValLength || defaultMaxValueLength;
            if ((value === null || value === void 0 ? void 0 : value.length) <= maxValueLength) {
                return value;
            }
            return _.truncate(value, { length: maxValueLength });
        };
        _this.renderOption = function (option) {
            var itemId = _this.props.itemId;
            var title = option.title, value = option.value;
            var trimmedOptionTitle = title === null || title === void 0 ? void 0 : title.trim();
            var trimmedOptionValue = value === null || value === void 0 ? void 0 : value.trim();
            if (value && !trimmedOptionValue) {
                return null;
            }
            if (!(trimmedOptionTitle && trimmedOptionValue)) {
                return React.createElement("li", { key: "option-item-" + itemId + "-value-" + (title !== null && title !== void 0 ? title : value) }, _this.getValue(title || value));
            }
            return (React.createElement("li", { key: "option-item-" + itemId + "-value-" + title },
                title,
                ": ",
                _this.getValue(value)));
        };
        _this.renderCollapseExpandButton = function () {
            var _a;
            var _b = (_a = _this.props.collapseSettings) !== null && _a !== void 0 ? _a : {}, numberOfOptionsToCollapseAfter = _b.numberOfOptionsToCollapseAfter, showMoreTitle = _b.showMoreTitle, showLessTitle = _b.showLessTitle, collapseButtonClassName = _b.collapseButtonClassName;
            return (React.createElement(TextButton, { className: collapseButtonClassName, suffixIcon: _this.state.isCollapsed ? React.createElement(ChevronDown, null) : React.createElement(ChevronUp, null), priority: TextButtonPriority.secondary, "data-hook": ProductLineItemOptionsDataHook.collapseExpandButton, onClick: function () {
                    return _this.setState(function (prevState) { return ({
                        numberOfOptionsToShow: prevState.isCollapsed ? _this.props.options.length : numberOfOptionsToCollapseAfter,
                        isCollapsed: !prevState.isCollapsed,
                    }); });
                } }, _this.state.isCollapsed ? showMoreTitle : showLessTitle));
        };
        var numberOfOptionsToCollapseAfter = ((_a = _this.props.collapseSettings) !== null && _a !== void 0 ? _a : {}).numberOfOptionsToCollapseAfter;
        var shouldCollapseAndExpand = numberOfOptionsToCollapseAfter && _this.props.options.length > numberOfOptionsToCollapseAfter;
        _this.state = {
            numberOfOptionsToShow: shouldCollapseAndExpand ? numberOfOptionsToCollapseAfter : _this.props.options.length,
            shouldCollapseAndExpand: shouldCollapseAndExpand,
            isCollapsed: shouldCollapseAndExpand,
        };
        return _this;
    }
    Options.prototype.render = function () {
        var _a = this.props, options = _a.options, className = _a.className;
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: st(classes.root, className), "data-hook": ProductLineItemDataHook.Options }, options.slice(0, this.state.numberOfOptionsToShow).map(this.renderOption)),
            this.state.shouldCollapseAndExpand && this.renderCollapseExpandButton()));
    };
    Options.displayName = 'ProductLineItem.Options';
    return Options;
}(React.PureComponent));
export { Options };
//# sourceMappingURL=Options.js.map